import SelectorBobinasPage from "../../pages/legacy/seleccionBobinas/SelectorBobinasPage";

const route = {
  key: "selectorBobinas",
  path: "/legacy/selector-bobinas/:dataAreaId/:id",
  component: SelectorBobinasPage,
  private: true,
  layout: "main",
  icon: "faLayerGroup",
  group: "sales",
  order: 21.51,
  permission: "legacy.salesorder.read"
};

export default route;
